(function () {
  const INFIME_KEY = "xxlipqvk5ty1";
  const INFIME_LANG = "en";

  // Same mapping logic you saw in Magento
  const COLOR_CODE = {
    "black": "BLK",
    "brown": "BRN",
    "pink": "PNK",
    "grey": "GRY",
    "gray": "GRY",
    "blue": "BLU",
    "red": "RED",
    "nude": "NUD",
    "violet": "VIO",
    "peach": "PCH",
    "purple": "PPL",
    "dark blue": "DBU",
    "rich brown": "RBRN"
  };

  function safeParseJSON(str) {
    try {
      return JSON.parse(str);
    } catch (e) {
      return null;
    }
  }

  function moneyNumberFromText(text) {
    // turns "RM149.90" into "149.90"
    if (!text) return "";
    return String(text).replace(/[^\d.]/g, "");
  }

  function getProductTitle() {
    // Works for most themes: product title is usually h1
    const h1 = document.querySelector("h1");
    return h1 ? h1.textContent.trim() : document.title;
  }

  function getCurrentUrl() {
    return window.location.href;
  }

  function getCurrentPriceNumber() {
    // Broadcast/Dawn style often has [itemprop="price"] or price elements
    const priceMeta = document.querySelector('[itemprop="price"]');
    if (priceMeta && priceMeta.getAttribute("content")) {
      return priceMeta.getAttribute("content");
    }

    const priceEl =
      document.querySelector('[data-product-price]') ||
      document.querySelector(".price") ||
      document.querySelector(".product__price");

    if (priceEl) return moneyNumberFromText(priceEl.textContent);

    return "";
  }

  function buildEcom() {
    const price = getCurrentPriceNumber();
    const title = getProductTitle();
    const url = getCurrentUrl();
    return JSON.stringify({ regular_price: price, title, url });
  }

  function mapToInfimeColor(colorText) {
    if (!colorText) return "BLK";

    const text = String(colorText).trim().toLowerCase();

    for (const key in COLOR_CODE) {
      if (text.includes(key)) {
        return COLOR_CODE[key];
      }
    }

    return "BLK";
  }

  function getSelectedColorFromVariantUI() {
    // 1) Try: selected swatch button (common)
    const swatchSelected =
      document.querySelector('.swatch input:checked + label') ||
      document.querySelector('.swatch input:checked') ||
      document.querySelector('[data-option-name="Color"] .is-selected') ||
      document.querySelector('[data-option-name="colour"] .is-selected');

    if (swatchSelected) {
      return (
        swatchSelected.getAttribute("aria-label") ||
        swatchSelected.getAttribute("title") ||
        swatchSelected.textContent
      );
    }

    // 2) Try: variant select dropdown
    const optionSelect =
      document.querySelector('select[name="options[Color]"]') ||
      document.querySelector('select[name="options[Colour]"]');

    if (optionSelect) {
      const opt = optionSelect.options[optionSelect.selectedIndex];
      return opt ? opt.textContent : "";
    }
    
    return "";
  }

  function updateInfimeDataset() {
    const wrap = document.querySelector(".product-infime");
    if (!wrap) return;

    const colorName = getSelectedColorFromVariantUI();
    const infimeColor = mapToInfimeColor(colorName);
    const ecom = buildEcom();

    wrap.dataset.infimeTryonColor = infimeColor;
    wrap.dataset.infimeTryonEcom = ecom;

    console.log("[Infime] Updated dataset:", {
      colorName,
      infimeColor,
      ecom
    });
  }

  function findInfimeAPI() {
    if (window.Infime) return window.Infime;
    if (window.infime) return window.infime;
    if (window.Tryon) return window.Tryon;
    return null;
  }

  function initInfimeIfNeeded(api) {
    if (!api) return false;
    if (api.__shopifyInitialized) return true;

    if (typeof api.init === "function") {
      api.init({ key: INFIME_KEY, lang: INFIME_LANG });
      api.__shopifyInitialized = true;
      return true;
    }

    if (typeof api.configure === "function") {
      api.configure({ key: INFIME_KEY, lang: INFIME_LANG });
      api.__shopifyInitialized = true;
      return true;
    }

    api.__shopifyInitialized = true;
    return true;
  }

  function hasOpen(api) {
    return (
      api &&
      (typeof api.open === "function" ||
        typeof api.launch === "function" ||
        typeof api.tryOn === "function")
    );
  }

  async function waitForInfimeOpen(timeoutMs = 4000) {
    const start = Date.now();

    while (Date.now() - start < timeoutMs) {
      const api = findInfimeAPI();

      if (api) {
        // try init early
        initInfimeIfNeeded(api);

        if (hasOpen(api)) return api;
      }

      await new Promise((r) => setTimeout(r, 100));
    }

    return null;
  }

  async function openTryOnWhenReady(payload) {
    const api = await waitForInfimeOpen(10000);

    if (!api) {
      console.error("[Infime] SDK not ready or failed to load.");
      alert("Infime is not ready yet (SDK not loaded / server error). Please try again.");
      return;
    }

    try {
      if (typeof api.close === "function") {
        api.close();
      }
    } catch (e) {
      console.warn("[Infime] close() failed:", e);
    }

    if (typeof api.open === "function") return api.open(payload);
    if (typeof api.launch === "function") return api.launch(payload);
    if (typeof api.tryOn === "function") return api.tryOn(payload);

    console.error("[Infime] No open method found. API keys:", Object.keys(api));
    alert("Infime loaded, but no open method found. Check console.");
  }

  // ===============================
  // Auto-update dataset (SAFE)
  // ===============================
  function safeUpdate() {
    try {
      updateInfimeDataset();
    } catch (e) {
      console.warn("[Infime] updateInfimeDataset failed:", e);
    }
  }

  // 1) Run once after DOM ready
  document.addEventListener("DOMContentLoaded", safeUpdate);

  // 2) Update when variant changes
  document.addEventListener("change", function () {
    safeUpdate();
  });

  // 3) Update when user clicks swatches
  document.addEventListener("click", function (e) {
    if (
      e.target.closest('[name*="Color"]') ||
      e.target.closest('[data-option-name*="Color"]') ||
      e.target.closest('[data-option-name*="colour"]') ||
      e.target.closest(".swatch") ||
      e.target.closest(".product__option") ||
      e.target.closest(".product-form__input")
    ) {
      safeUpdate();
    }
  });

  // 4) Handle Try-on button click
  let infimeOpening = false;

  document.addEventListener("click", async function (e) {
    const btn = e.target.closest(".product-infime .infime-try3d");
    if (!btn) return;

    e.preventDefault();

    if (infimeOpening) return;
    infimeOpening = true;
    btn.disabled = true;

    try {
      safeUpdate();

      const wrap = btn.closest(".product-infime");
      const tryonId = wrap?.dataset?.infimeTryonId;
      const color = wrap?.dataset?.infimeTryonColor;
      const ecom = safeParseJSON(wrap?.dataset?.infimeTryonEcom || "{}") || {};

      console.log("[Infime] Click payload:", { tryonId, color, ecom });

      await openTryOnWhenReady({ tryonId, color, ecom });
    } catch (error) {
      console.error("[Infime] Click failed:", error);
    } finally {
      setTimeout(() => {
        infimeOpening = false;
        btn.disabled = false;
      }, 800);
    }
  });
})();